import React, { Component } from 'react';
import Base from '../../rebase';
import Firebase from 'firebase';
import { Redirect } from "react-router-dom";

class Logout extends Component {

  componentWillMount() {
    console.log("component will mount");
    Firebase.auth().signOut().then(() => {
      console.log("Successfully logged out");
      this.props.logout();
      //reload page
    }).then(error => {
      console.log("Couldn't logout");
    });
  }

  render() {
    return(
      <div>
      jklghgkj
      <Redirect to="/" />
      </div>
    );
  }
}

export default Logout;


// WEBPACK FOOTER //
// ./src/reusable_components/page_components/Logout.jsx